<template>
    <section>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <form @submit.prevent="changePassword()" novalidate>
        <div class="pda-default">

            
            <div class="t-headline5">
                {{$t('329')}}
                
            </div>
            <div class="t-body3 mgt-6 t-color-bodyGrayA">
                {{$t('330')}}
               
            </div>

            <div class="mgt-38">
                
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && currentPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="currentPasswordEl"
                >
                    
                    <input type="password" class="mdc-text-field__input"
                        v-model="currentPassword"
                        v-validate="'required'"
                        ref="currentPassword"
                        id="currentPassword"
                        name="currentPassword"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('331')}}
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                
            </div>
        </div>
        <hr class="divider mgt-4">
        <div class="pda-default mgt-4">
            

            <div class="">
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && newPasswordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="newPasswordEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{newPasswordValidIcon}}
                    </i>
                    <input type="password" class="mdc-text-field__input"
                        v-model="newPassword"
                        v-validate="'required|min:8|verify_password'"
                        ref="newPassword"
                        id="newPassword"
                        name="newPassword"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('332')}}
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''">
                    <span>
                        {{$t('333')}}
                        
                    </span>
                </div>
                

                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full mgt-17"
                    :class="submitState && newPasswordConfirmInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="newPasswordConfirmEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{newPasswordConfirmValidIcon}}
                    </i>
                    <input type="password" class="mdc-text-field__input"
                        v-model="newPasswordConfirm"
                        v-validate="'required|confirmed:newPassword'"
                        ref="newPasswordConfirm"
                        id="newPasswordConfirm"
                        name="newPasswordConfirm"
                        maxlength="50"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('334')}}
                            
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && newPasswordInvalidCheck ? 't-color-mainBtn' : ''">
                    <span>
                        {{submitState && newPasswordInvalidCheck ? $t('341') : $t('335')}}
                        
                        
                    </span>
                </div>

                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-mainBtn">
                    <span v-show="submitState && newPasswordConfirmInvalidCheck"></span>
                </div>
            </div>

            

            <div class="mgt-50">
                <button class="mdc-button mdc-button--raised btn-red mr8">
                    {{$t('336')}}
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="nextChangePassword()" @keypress="nextChangePassword()" type="button" tabindex="0">
                    {{$t('337')}}
                </button>
            </div>
        </div>
        
    </form>

    </section>
    
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from '@/api/memberApi.js'
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'

export default {
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
            currentPasswordTextField: null,
            newPasswordTextField: null,
            newPasswordConfirmTextField: null,
            submitState: false,
            newPasswordValidIcon: '',
            newPasswordConfirmValidIcon: '',
        }
    },
    components: {
        TopAppBar
    },

    watch: {
        '$route' (to, from) {
           this.setTopAppBarCloseOnly('')
        }
    },

    mixins: [topAppBarMixin],
    computed : {
        currentPasswordInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('currentPassword')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.currentPasswordTextField.valid === !returnValue ? '' : this.currentPasswordTextField.valid = !returnValue
            return returnValue
        },

        newPasswordInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('newPassword')) {
                    returnValue = true
                    this.newPasswordValidIcon = 'warning'
                }else {
                    returnValue = false
                    this.newPasswordValidIcon = 'check'
                }
            }
            this.newPasswordTextField.valid === !returnValue ? '' : this.newPasswordTextField.valid = !returnValue
            return returnValue
        },

        newPasswordConfirmInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('newPasswordConfirm')) {
                    returnValue = true
                    this.newPasswordConfirmValidIcon = 'warning'
                }else {
                    returnValue = false
                    this.newPasswordConfirmValidIcon = 'check'
                }
            }
            this.newPasswordConfirmTextField.valid === !returnValue ? '' : this.newPasswordConfirmTextField.valid = !returnValue
            return returnValue
        },

    },

    mounted() {
        this.setMaterialUi()
        this.$refs.currentPassword.focus()
         this.setTopAppBarCloseOnly('')
    },

    methods: {
        setMaterialUi() {
            this.currentPasswordTextField = new MDCTextField(document.querySelector('#currentPasswordEl'))
            this.currentPasswordTextField.useNativeValidation = false
            this.newPasswordTextField = new MDCTextField(document.querySelector('#newPasswordEl'))
            this.newPasswordTextField.useNativeValidation = false
            this.newPasswordConfirmTextField = new MDCTextField(document.querySelector('#newPasswordConfirmEl'))
            this.newPasswordConfirmTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        changePassword() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                        let params = {
                            password: this.currentPassword,
                            newPassword: this.newPassword
                        }
                        let responseData = null
                        let alertParams = null
                        memberApi.changePassword(params).then((response) => {
                            responseData = response.data.data
                            
                            if (responseData) {
                                alertParams = {
                                    title: this.$t('325'), 
                                    content: this.$t('326'+ +'327'), 
                                    accept: this.$t('328'), 
                                }

                                this.$alert(alertParams).then(() => {
                                    this.$router.push('/login')
                                })
                            } else {
                                this.$snackOpen({contents:this.$t('Todo-비밀번호 변경에 실패하였습니다. 관리자에게 문의 바랍니다.')}).then(() => {})
                            }
                            
                        }).catch((err) => {
                            responseData = err.response.data.meta
                            this.$snackOpen({contents:this.$t('344'), btnDisplayYN:true, btnDisplay:this.$t('345')}).then(() => {})
                            
                        })
                }
            })
            
        },

        nextChangePassword() {
            this.$router.push('/login')
        },
        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
    }
}
</script>